import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../context/AuthContext";

const AdminPanel = () => {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchEmail, setSearchEmail] = useState("");

  useEffect(() => {
    // Only allow specific admin emails
    const ADMIN_EMAILS = [
      "noryq.official@gmail.com", // ← CHANGE THIS to your email
      // Add more admin emails here
    ];

    if (!user || !ADMIN_EMAILS.includes(user.email)) {
      alert("⛔ Access Denied. Admin only.");
      window.location.href = "/";
      return;
    }

    loadAllUsers();
  }, [user]);

  const loadAllUsers = async () => {
    try {
      // ✅ CORRECT FIREBASE V9 SYNTAX
      const usersCollection = collection(db, "users");
      const snapshot = await getDocs(usersCollection);

      const usersData = snapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));

      setUsers(usersData);
      setLoading(false);
    } catch (error) {
      console.error("Error loading users:", error);
      alert("Error loading users: " + error.message);
      setLoading(false);
    }
  };

  const grantPremium = async (userEmail, userUid) => {
    if (!window.confirm(`Grant Premium to ${userEmail}?`)) return;

    try {
      // ✅ CORRECT FIREBASE V9 SYNTAX
      const userRef = doc(db, "users", userUid);
      await updateDoc(userRef, {
        isPremium: true,
        premiumActivatedAt: new Date().toISOString(),
        premiumType: "manual-admin",
      });

      alert(`✅ Premium granted to ${userEmail}!`);
      loadAllUsers(); // Reload
    } catch (error) {
      console.error("Error granting premium:", error);
      alert("Error: " + error.message);
    }
  };

  const revokePremium = async (userEmail, userUid) => {
    if (!window.confirm(`Revoke Premium from ${userEmail}?`)) return;

    try {
      // ✅ CORRECT FIREBASE V9 SYNTAX
      const userRef = doc(db, "users", userUid);
      await updateDoc(userRef, {
        isPremium: false,
        premiumRevokedAt: new Date().toISOString(),
      });

      alert(`✅ Premium revoked from ${userEmail}!`);
      loadAllUsers(); // Reload
    } catch (error) {
      console.error("Error revoking premium:", error);
      alert("Error: " + error.message);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#fff",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚙️</div>
          <div style={{ fontSize: "1.5rem" }}>Loading Admin Panel...</div>
        </div>
      </div>
    );
  }

  const filteredUsers = users.filter(
    (u) =>
      !searchEmail ||
      u.email?.toLowerCase().includes(searchEmail.toLowerCase()),
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "2rem",
        fontFamily: '"DM Sans", sans-serif',
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header */}
        <div
          style={{
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            borderRadius: "16px",
            padding: "2rem",
            marginBottom: "2rem",
            color: "#fff",
          }}
        >
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              marginBottom: "0.5rem",
            }}
          >
            🛡️ Admin Panel
          </h1>
          <p style={{ opacity: 0.9 }}>Manage users and premium access</p>
        </div>

        {/* Stats Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "1rem",
            marginBottom: "2rem",
          }}
        >
          <div
            style={{
              background: "rgba(255,255,255,0.15)",
              backdropFilter: "blur(10px)",
              borderRadius: "16px",
              padding: "1.5rem",
              color: "#fff",
            }}
          >
            <div style={{ fontSize: "0.875rem", opacity: 0.8 }}>
              Total Users
            </div>
            <div style={{ fontSize: "2rem", fontWeight: "700" }}>
              {users.length}
            </div>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.15)",
              backdropFilter: "blur(10px)",
              borderRadius: "16px",
              padding: "1.5rem",
              color: "#fff",
            }}
          >
            <div style={{ fontSize: "0.875rem", opacity: 0.8 }}>
              Premium Users
            </div>
            <div style={{ fontSize: "2rem", fontWeight: "700" }}>
              {users.filter((u) => u.isPremium).length}
            </div>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.15)",
              backdropFilter: "blur(10px)",
              borderRadius: "16px",
              padding: "1.5rem",
              color: "#fff",
            }}
          >
            <div style={{ fontSize: "0.875rem", opacity: 0.8 }}>Free Users</div>
            <div style={{ fontSize: "2rem", fontWeight: "700" }}>
              {users.filter((u) => !u.isPremium).length}
            </div>
          </div>
        </div>

        {/* Search */}
        <div
          style={{
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            borderRadius: "16px",
            padding: "1.5rem",
            marginBottom: "2rem",
          }}
        >
          <input
            type="text"
            placeholder="🔍 Search by email..."
            value={searchEmail}
            onChange={(e) => setSearchEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              fontSize: "1rem",
              border: "2px solid rgba(255,255,255,0.3)",
              borderRadius: "12px",
              background: "rgba(255,255,255,0.1)",
              color: "#fff",
              outline: "none",
            }}
          />
        </div>

        {/* Users Table */}
        <div
          style={{
            background: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            borderRadius: "16px",
            overflow: "hidden",
          }}
        >
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                color: "#fff",
              }}
            >
              <thead>
                <tr style={{ background: "rgba(0,0,0,0.2)" }}>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "left",
                      fontWeight: "700",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "left",
                      fontWeight: "700",
                    }}
                  >
                    Email
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "center",
                      fontWeight: "700",
                    }}
                  >
                    Status
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "center",
                      fontWeight: "700",
                    }}
                  >
                    Recs
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "center",
                      fontWeight: "700",
                    }}
                  >
                    Joined
                  </th>
                  <th
                    style={{
                      padding: "1rem",
                      textAlign: "center",
                      fontWeight: "700",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((userData) => (
                  <tr
                    key={userData.uid}
                    style={{
                      borderTop: "1px solid rgba(255,255,255,0.1)",
                    }}
                  >
                    <td style={{ padding: "1rem" }}>
                      {userData.displayName || "N/A"}
                    </td>
                    <td style={{ padding: "1rem", fontSize: "0.875rem" }}>
                      {userData.email}
                    </td>
                    <td style={{ padding: "1rem", textAlign: "center" }}>
                      {userData.isPremium ? (
                        <span
                          style={{
                            background:
                              "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                            padding: "0.375rem 0.75rem",
                            borderRadius: "8px",
                            fontSize: "0.75rem",
                            fontWeight: "700",
                          }}
                        >
                          👑 PREMIUM
                        </span>
                      ) : (
                        <span
                          style={{
                            background: "rgba(255,255,255,0.1)",
                            padding: "0.375rem 0.75rem",
                            borderRadius: "8px",
                            fontSize: "0.75rem",
                          }}
                        >
                          Free
                        </span>
                      )}
                    </td>
                    <td style={{ padding: "1rem", textAlign: "center" }}>
                      {userData.recommendationCount || 0}
                    </td>
                    <td
                      style={{
                        padding: "1rem",
                        textAlign: "center",
                        fontSize: "0.875rem",
                      }}
                    >
                      {userData.createdAt
                        ? new Date(userData.createdAt).toLocaleDateString()
                        : "N/A"}
                    </td>
                    <td style={{ padding: "1rem", textAlign: "center" }}>
                      {userData.isPremium ? (
                        <button
                          onClick={() =>
                            revokePremium(userData.email, userData.uid)
                          }
                          style={{
                            padding: "0.5rem 1rem",
                            background: "rgba(231, 76, 60, 0.8)",
                            border: "none",
                            borderRadius: "8px",
                            color: "#fff",
                            cursor: "pointer",
                            fontSize: "0.875rem",
                            fontWeight: "600",
                          }}
                        >
                          Revoke
                        </button>
                      ) : (
                        <button
                          onClick={() =>
                            grantPremium(userData.email, userData.uid)
                          }
                          style={{
                            padding: "0.5rem 1rem",
                            background:
                              "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                            border: "none",
                            borderRadius: "8px",
                            color: "#fff",
                            cursor: "pointer",
                            fontSize: "0.875rem",
                            fontWeight: "600",
                          }}
                        >
                          Grant
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {filteredUsers.length === 0 && (
          <div
            style={{
              textAlign: "center",
              padding: "3rem",
              color: "#fff",
              opacity: 0.7,
            }}
          >
            No users found
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPanel;
